// extracted by mini-css-extract-plugin
module.exports = {"socialShareLink":"SocialShareLink-module--socialShareLink--1Dnvf"};